import {
  createNgReactBridgeDirectiveFn,
  createNgReactBridgeConstant
} from '../../react-bridge'

import { csVulnTrendChartTooltip } from './cs-vuln-trend-chart-tooltip.directive'
import { vulnTrendChartConstants } from './cs-vuln-trend-chart-constants'

createNgReactBridgeConstant(
  'VULN_TREND_CHART_CONSTANTS',
  vulnTrendChartConstants
)
createNgReactBridgeDirectiveFn(
  'csVulnTrendChartTooltip',
  csVulnTrendChartTooltip
)
